Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectType = exports.inputTypeRegistry = exports.objectTypeRegistry = exports.ObjectTypeError = exports.compileObjectType = void 0;
const objectType_1 = require("./compiler/objectType");
const registry_1 = require("./registry");
const interfaceTypeRegistry_1 = require("../interfaceType/interfaceTypeRegistry");
var objectType_2 = require("./compiler/objectType");
Object.defineProperty(exports, "compileObjectType", { enumerable: true, get: function () { return objectType_2.compileObjectType; } });
var error_1 = require("./error");
Object.defineProperty(exports, "ObjectTypeError", { enumerable: true, get: function () { return error_1.ObjectTypeError; } });
var registry_2 = require("./registry");
Object.defineProperty(exports, "objectTypeRegistry", { enumerable: true, get: function () { return registry_2.objectTypeRegistry; } });
Object.defineProperty(exports, "inputTypeRegistry", { enumerable: true, get: function () { return registry_2.inputTypeRegistry; } });
function ObjectType(options) {
    return (target) => {
        if (options && options.implements) {
            options.implements.forEach((interfaceClass) => {
                const implementors = interfaceTypeRegistry_1.interfaceTypeImplementors.get(interfaceClass);
                if (!implementors) {
                    interfaceTypeRegistry_1.interfaceTypeImplementors.set(interfaceClass, [target]);
                }
                else {
                    implementors.push(target);
                }
            });
        }
        const config = { name: target.name, ...options };
        const outputTypeCompiler = () => objectType_1.compileObjectTypeWithConfig(target, config);
        registry_1.objectTypeRegistry.set(target, outputTypeCompiler);
    };
}
exports.ObjectType = ObjectType;
//# sourceMappingURL=ObjectType.js.map